function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledSecurityLogos } from "./security-logos.scss";
import DefaultProps from "./default-props";
import PictureComponent from "components/core/picture/picture-component";
import classnames from "classnames";
export const LOGO_SIZES = {
    LARGE: "large",
    MEDIUM: "medium"
};
const LOGOS = [
    "/static/img/security/gdpr_v2.png",
    "/static/img/security/iso_27001_v2.png",
    "/static/img/security/iso_27018_v2.png",
    "/static/img/security/soc_v2.png",
    "/static/img/security/hipaa_v2.png"
];
class SecurityLogos extends PureComponent {
    render() {
        const { logosNumber } = this.props;
        const logosToRender = LOGOS.slice(0, logosNumber);
        return /*#__PURE__*/ _jsx(StyledSecurityLogos, {
            className: "security-logos",
            children: logosToRender.map((logo, index)=>this.renderLogo(logo, index))
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "renderLogo", (logo, index)=>{
            const { smallLogos } = this.props;
            return /*#__PURE__*/ _jsx("div", {
                className: "security-logo-wrapper",
                children: /*#__PURE__*/ _jsx(PictureComponent, {
                    src: logo,
                    className: classnames("security-logo", {
                        "small-logo": smallLogos
                    })
                })
            }, index);
        });
    }
}
export { SecurityLogos as default };
SecurityLogos.defaultProps = DefaultProps;
